import UserStatusEnum from '@constants/enums/user/status';

import i18n from '@plugins/i18n';

import { Collection, Adviser } from '@/models';

export class AdviserCollection extends Collection {
    static type = 'AdviserCollection';
    static endpoint = Adviser.api.index;
    static model = Adviser;

    get headers() {
        return [
            this.createHeader('name', i18n.t('name'), {
                width: '18rem',
                minWidth: '18rem',
                filterable: true,
                sortable: true,
                sticky: true
            }),
            this.createHeader('status', i18n.t('status'), {
                filterable: true,
                sortable: false,
                width: '10rem',
                format: 'enum',
                enum: UserStatusEnum,
                enumA11yKey: 'enums.user_status',
                enumTypes: {
                    [UserStatusEnum.ACTIVE]: 'success',
                    [UserStatusEnum.INACTIVE]: 'grey',
                    [UserStatusEnum.SUSPENDED]: 'error',
                    [UserStatusEnum.UNVERIFIED]: 'warning'
                }
            }),
            this.createHeader('gi_ref', i18n.t('gi_ref'), {
                filterable: true,
                width: '9rem'
            }),
            this.createHeader('fca_number', i18n.t('fca_number'), {
                filterable: true,
                width: '12rem'
            }),
            this.createHeader('control', '', {
                format: 'control',
                width: '7rem',
                persistent: true
            })
        ];
    }
}

export default AdviserCollection;
